import { Quadkey, XyoWorldGeotoken } from '@xyo-network/sdk-xyoworld-js'
import { PropsWithChildren, useContext, useEffect, useState } from 'react'

import { GeotokensContext } from '../Geotokens'
import Context from './Context'

interface Props {
  enabled?: boolean
  quadkey: Quadkey
}

const Provider: React.FC<PropsWithChildren<Props>> = (props) => {
  const { geotokens } = useContext(GeotokensContext)
  const { quadkey } = props
  const enabled = true

  const [geotoken, setGeotoken] = useState<XyoWorldGeotoken | null>()
  const [refreshCount, setRefreshCount] = useState(0)

  useEffect(() => {
    if (geotokens && enabled) {
      const geotoken = geotokens.factory().get(quadkey)
      setGeotoken(geotoken)
    }
  }, [quadkey, geotokens, refreshCount, enabled])

  const refresh = () => {
    setRefreshCount(refreshCount + 1)
  }

  return <Context.Provider value={{ geotoken, quadkey, refresh }}>{props.children}</Context.Provider>
}

export default Provider
